import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import carouselData from "../../data/RecentUpdatesData.json";
import "./RecentUpdatesSection.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import { baseUrl, allowedPeople } from "../../Constants";
import { useMsal } from "@azure/msal-react";
import AddRecentUpdates from "../AddEventFolder/AddRecentUpdates";

// Group data into chunks of 4
const chunkArray = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

// Arrows
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaArrowRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaArrowLeft />
  </div>
);

const Carousel = () => {
  const chunkedData = chunkArray(carouselData, 4);
  const [recentUpdates, setrecentUpdates] = useState([]);
  const [addRecentUpdatePopup, setaddRecentUpdatePopup] = useState(false);
  const [confirmatuinPopup, setconfirmatuinPopup] = useState(false);
  const [itemsToDelete, setitemsToDelete] = useState();
  const [editItem, seteditItem] = useState();

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  console.log("loggedInEnterpriseId", loggedInEnterpriseId);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Show one slide (group of 4 items)
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const getRecentUpdateData = () => {
    axios
      .get(`${baseUrl}/getrecentupdate`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const res = response.data.results;
        if (res) setrecentUpdates(chunkArray(res, 4)); // Set the data
        console.log("getFeatureResponse", response);
      })
      .catch((error) => {
        console.log(error);
        console.log("getFeatureResponse", error);
      });
  };

  const deleteItem = async (id) => {
    try {
      const res = await axios.post(
        `${baseUrl}/deleterecentupdate`,
        { id },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      getRecentUpdateData();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getRecentUpdateData();

    // setFeaturedProgState(currentItems);
  }, [addRecentUpdatePopup]);

  return (
    <>
      <div className="recent-updates-extra-row">
        {/* <div className="recent-updates-row row1" data-aos="fade-left"> */}
        <div className="recent-updates-row row1">
          <div className="recent-updates-box">
            <div className="heading-box">
              <h2 className="main-headings">Recent Updates</h2>
              {allowedPeople.includes(loggedInEnterpriseId) && (
                <button
                  type="button"
                  onClick={() => {
                    seteditItem(null);
                    setaddRecentUpdatePopup(true);
                  }}
                  className="add-prog-button ru-add"
                >
                  <AddIcon />
                  Add Update
                </button>
              )}
            </div>
            <p className="recent-subtext">
              Explore our successfully concluded programs, empowering
              participants with skill development opportunities, certification,
              and recognition.
            </p>
          </div>
        </div>
        {/* <div className="recent-updates-row row2" data-aos="fade-right"> */}
        <div className="recent-updates-row row2">
          <div className="recent-updates-box">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/updates-discussion-img.png"
              }
              alt="building"
              className="building-img"
            />
          </div>
        </div>
      </div>

      {/* <div className="recent-updates-row row3" data-aos="fade-up"> */}
      <div className="recent-updates-row row3">
        <div className="recent-updates-box">
          <div className="carousel-wrapper-horizontal">
            <Slider {...settings}>
              {recentUpdates &&
                recentUpdates.map((group, groupIndex) => (
                  // {chunkedData.map((group, groupIndex) => (
                  <div className="carousel-slide" key={groupIndex}>
                    <div className="carousel-grid">
                      {group.map((item, index) => (
                        <div className="carousel-card-vertical" key={index}>
                          <div className="card-content">
                            <div className="icon">
                              <img
                                src={item.icon}
                                alt="icon"
                                className="icon-imgs"
                              />
                            </div>
                            <div className="text-content">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <h3>{item.title}</h3>
                                {allowedPeople.includes(
                                  loggedInEnterpriseId
                                ) && (
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {/* <EditNoteRoundedIcon
                                      sx={{
                                        color: "gray",
                                        display: "inline",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        seteditItem(item);
                                        setaddRecentUpdatePopup(true);
                                      }}
                                    /> */}
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/images/Home/edit-icon.png"
                                      }
                                      alt="icon"
                                      className="edit-delete-icons"
                                      onClick={() => {
                                        seteditItem(item);
                                        setaddRecentUpdatePopup(true);
                                      }}
                                    />
                                    {/* <DeleteRoundedIcon
                                      sx={{
                                        color: "gray",
                                        display: "inline",
                                        cursor: "pointer",
                                        fontSize: "1rem",
                                      }}
                                      onClick={() => {
                                        setconfirmatuinPopup(true);
                                        setitemsToDelete(item.id);
                                      }}
                                    /> */}
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/images/Home/delete-icon.png"
                                      }
                                      alt="icon"
                                      className="edit-delete-icons"
                                      onClick={() => {
                                        setconfirmatuinPopup(true);
                                        setitemsToDelete(item.id);
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                              <p>
                                {item.description}
                                {item.link && item.link.trim() !== "" && (
                                  <>
                                    {" "}
                                    <a
                                      href={item.link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View more...
                                    </a>
                                  </>
                                )}
                              </p>
                            </div>
                          </div>
                          {/* {
              (allowedPeople.includes(loggedInEnterpriseId)) &&
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>

                          <EditNoteRoundedIcon sx={{ color: 'gray', display: 'inline', cursor: 'pointer' }} onClick={() => { seteditItem(item); setaddRecentUpdatePopup(true); }} />
                          <DeleteRoundedIcon sx={{ color: 'gray', display: 'inline', cursor: 'pointer', fontSize: '1rem' }} onClick={() => { setconfirmatuinPopup(true); setitemsToDelete(item.id) }} />
                        </div>
                        } */}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>

      {addRecentUpdatePopup && (
        <div className="fullscreen-popup">
          {/* <div className="popup-content"> */}

          <AddRecentUpdates
            item={editItem ? editItem : null}
            getRecentUpdateData={getRecentUpdateData}
            setaddRecentUpdatePopup={setaddRecentUpdatePopup}
          />

          {/* <Link to="/response" className="confirm" onClick={confirmSubmit}>Yes, Submit</Link>
                        <button className="cancel" onClick={closePopup}>Cancel</button> */}
          {/* </div> */}
        </div>
      )}

      {/* Full-Screen Popup Modal */}
      {confirmatuinPopup && (
        <div className="fullscreen-popup">
          <div className="popup-content">
            <div className="questions">Are you sure you want to submit?</div>
            <p>Once submitted, you cannot change your answers.</p>
            <div className="popup-buttons">
              <button
                className="confirm"
                onClick={() => {
                  deleteItem(itemsToDelete);
                  setconfirmatuinPopup(false);
                }}
              >
                Yes, delete!
              </button>
              <button
                className="cancel"
                onClick={() => setconfirmatuinPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Carousel;
